export enum DashboardType {
  DASHBOARD_ACCOUNT = 'DEA',
  DASHBOARD_SUBSCRIPTION = 'DES',
}

export enum CryptoConfig {
  SERVICE = 'paymentGateway',
  CLIENT = 'passerapp',
}

export enum FileType {
  pdf = 'application/pdf',
  html = 'text/html',
  excel = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
}
